module.exports = __webpack_public_path__ + "img/icon-procedure.d9aae701.svg";